// extracted by mini-css-extract-plugin
export default {"frame":"frame_frame__ZW9CR"};